export const DATE_FORMAT_FULL = 'EEEE d MMMM yyyy';
export const DATE_FORMAT_API = 'yyyy-MM-dd';
export const DATE_FORMAT_APP = 'yyyy/MM/dd';
export const DATE_PICKER_FORMAT = 'dd/MM/yyyy';
export const DATE_PICKER_FORMAT_MONTH = 'MM/yyyy';
export const DATE_TIME_FORMAT_API = 'HH:mm';
export const DATE_TIME_FORMAT_API_SECONDS = 'HH:mm:ss';
export const DATE_FORMAT_DAY_TIME = 'EEE, dd/MM/yyyy - HH:mm a';
